module.exports = __webpack_public_path__ + "static/instagram-ededf456cfaee72448ae3077f5a5af8d.svg";